import gql from "graphql-tag";

export const queueSummonerReview = `enqueueSummonerReview (regionId: $regionId, summonerName: $summonerName, season: $season) {
    reason
    success
    summonerName
    regionId
  }`;

const QUEUE_SUMMONER_REVIEW = gql`
    mutation requestRiotVerificationCode (
        $summonerName: String!,
        $regionId: String!,
        $season: String!
    ) {
        ${queueSummonerReview}
    }
`;

export default QUEUE_SUMMONER_REVIEW;
